import { IUser } from "../../models/user.model";

export interface AuthState {
    isLogged: boolean;
    user: IUser | null;
}

export const authInitialState: AuthState = {
    isLogged: false,
    user: null,
}